import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import AuthService from './services/AuthService';
import App from './App';
import Login from './views/login/Login';
import RoutingService from './services/RoutingService';
import StorageService from './services/StorageService';
import 'react-hint/css/index.css';
import 'react-select-plus/dist/react-select-plus.css';
import 'react-toggle/style.css';
import { unregister } from './registerServiceWorker';
import RESTService from './services/RESTService';
import Signup from './views/signup/Signup';
unregister();
const SS = new StorageService();
const auth = new AuthService();
const RS = new RoutingService();
const connect = new RESTService();
connect.setRS(RS);

let p1 = SS.getUserData('current-tenant').then(val => {
	RS.setCurrentTenant(val);
	console.log('Current Tenant:' + val);
});
let p2 = SS.getUserData('current-sandbox').then(val => {
	RS.setCurrentEnvironment(val);
	console.log('Current Sandbox:' + val);
});
let p3 = SS.getUserData('current-application').then(val => {
	RS.setCurrentApplication(val);
	console.log('Current Application:' + val);
});
let p4 = SS.getUserData('current-config')
	.then(val => {
		RS.setCurrentConfiguration(val);
		if (val) {
			console.log('Current Application:' + val.name + val.version);
		}
	})
	.catch(err => {
		console.log(err.message);
	});

Promise.all([p1, p2, p3, p4]).then(() => {
	ReactDOM.render(
		<BrowserRouter>
			<Switch>
				<Route path="/login" component={Login} />
				<Route path="/signup" component={Signup} />
				<Route
					render={props =>
						auth.isAuthenticated() ? (
							<App {...props} />
						) : (
							<Redirect
								to={{
									pathname: '/login',
									state: { from: props.location }
								}}
							/>
						)
					}
				/>
			</Switch>
		</BrowserRouter>,
		document.getElementById('root')
	);
});



// WEBPACK FOOTER //
// ./src/index.js